import { ReactNode } from "react";
import Loading from "../ui/Loading";

interface ConfirmationModalProps {
    modalTitle: string;
    // modalSubTitle: string;
    modalSubTitle: ReactNode;
    onCancel: () => void;
    onConfirm: () => void;
    isLoading: boolean;
}

export default function ConfirmationModal({ modalTitle, modalSubTitle, onCancel, onConfirm, isLoading }: ConfirmationModalProps) {
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
            <div className="relative bg-white rounded shadow w-11/12 sm:w-96 md:w-[400px] p-6">
                <div className="space-y-7">
                    <div>
                        <h2 className="text-base font-medium text-gray-900">{modalTitle}</h2>
                        <p className="mt-2 text-sm text-gray-600">{modalSubTitle}</p>
                    </div>
                    {isLoading ? (
                        <div className="grid grid-cols-1 gap-2">
                            <button onClick={onConfirm} className="w-full py-1.5 rounded text-sm font-medium bg-white border disabled:cursor-not-allowed">
                                <div className="flex items-center w-full justify-center">
                                    <Loading setH={'h-[20px]'} setBgColor="white"/>
                                    Loading...
                                </div>
                            </button>
                        </div>
                    ) : (
                        <div className="grid grid-cols-2 gap-2">
                            <button onClick={onCancel} className="w-full py-1.5 rounded text-sm font-medium bg-gray-300 text-black disabled:cursor-not-allowed">
                                Back
                            </button>
                            <button onClick={onConfirm} className="w-full py-1.5 rounded text-sm font-medium bg-cbColor text-white disabled:cursor-not-allowed">
                                Yes
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
